// // src/pages/me/negotiations/index.js
// import React, { useState } from 'react';
// import { Link } from 'react-router-dom';
// import { useQuery } from '@tanstack/react-query';
// import { motion } from 'framer-motion';
// import { formatDistanceToNow } from 'date-fns';
// import { ar } from 'date-fns/locale';
// import Client from '../../../utils/client';
// import empty_box from '../../../images/empty_box.png';

// const NegotiationsList = () => {
//   const [filter, setFilter] = useState('all');
//   const currentUserId = localStorage.getItem('user_id');

//   // Fetch negotiations with last messages
//   const { data: negotiations, isLoading, error, refetch } = useQuery({
//     queryKey: ['negotiations', filter],
//     queryFn: async () => {
//       const response = await Client.get(`/negotiations/last-messages`).then(
//         (res) => res.data
//       );
//       // Filter by status if not 'all'
//       if (filter !== 'all') {
//         return response.filter(neg => neg.status === filter);
//       }
//       return response;
//     },
//     initialData: [],
//     enabled: !!currentUserId
//   });

//   const getStatusBadge = (status) => {
//     switch(status) {
//       case 'ACTIVE':
//         return { text: 'نشط', color: 'bg-green-100 text-green-800', icon: '🟢' };
//       case 'COMPLETED':
//         return { text: 'مكتمل', color: 'bg-blue-100 text-blue-800', icon: '✅' };
//       case 'CANCELLED':
//         return { text: 'ملغى', color: 'bg-red-100 text-red-800', icon: '❌' };
//       default:
//         return { text: status || 'غير محدد', color: 'bg-gray-100 text-gray-800', icon: '⚪' };
//     }
//   };

//   const getTypeIcon = (type) => {
//     switch(type) {
//       case 'CROP':
//         return '🌾';
//       case 'INPUT':
//         return '🧪';
//       case 'SERVICE':
//         return '🔧';
//       default:
//         return '📦';
//     }
//   };

//   const getTypeText = (type) => {
//     switch(type) {
//       case 'CROP':
//         return 'محصول';
//       case 'INPUT':
//         return 'مدخل زراعي';
//       case 'SERVICE':
//         return 'خدمة';
//       default:
//         return type;
//     }
//   };

//   const getCounterpartyName = (negotiation) => {
//     if (currentUserId === negotiation.buyerId) {
//       return negotiation.seller?.name || 'البائع';
//     }
//     return negotiation.buyer?.name || 'المشتري';
//   };

//   const filters = [
//     { id: 'all', label: 'الكل', icon: '📋' },
//     { id: 'ACTIVE', label: 'نشط', icon: '🟢' },
//     { id: 'COMPLETED', label: 'مكتمل', icon: '✅' },
//     { id: 'CANCELLED', label: 'ملغى', icon: '❌' }
//   ];

//   // Skeleton loader component
//   const SkeletonLoader = () => (
//     <div dir="rtl" className="space-y-4">
//       {[...Array(5)].map((_, i) => (
//         <div key={i} className="flex flex-row-reverse items-center justify-between gap-3 p-4 bg-gray-100 border rounded-xl shadow-sm animate-pulse">
//           <div className="flex flex-col text-right w-full">
//             <div className="h-5 bg-gray-300 rounded w-3/4 mb-2"></div>
//             <div className="h-4 bg-gray-300 rounded w-1/2"></div>
//             <div className="h-3 bg-gray-300 rounded w-1/3 mt-2"></div>
//           </div>
//           <div className="w-14 h-14 bg-gray-300 rounded-xl"></div>
//         </div>
//       ))}
//     </div>
//   );

//   if (isLoading) {
//     return (
//       <div className="w-full px-4 lg:px-20 relative">
//         <h1 className="text-end font-bold text-2xl lg:text-3xl my-10 text-primary">
//           المفاوضات
//         </h1>
//         <SkeletonLoader />
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="w-full px-4 lg:px-20 relative">
//         <h1 className="text-end font-bold text-2xl lg:text-3xl my-10 text-primary">
//           المفاوضات
//         </h1>
//         <div className="text-center py-12 bg-red-50 rounded-xl">
//           <p className="text-red-500 mb-4">حدث خطأ أثناء تحميل المفاوضات</p>
//           <button 
//             onClick={() => refetch()}
//             className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition"
//           >
//             إعادة المحاولة
//           </button>
//         </div>
//       </div>
//     );
//   }

//   const filteredNegotiations = negotiations || [];

//   return (
//     <div className="w-full px-4 lg:px-20 relative">
//       <h1 className="text-end font-bold text-2xl lg:text-3xl my-10 text-primary">
//         المفاوضات
//       </h1>

//       {/* Filters */}
//       <div className="flex flex-wrap justify-end gap-2 mb-6">
//         {filters.map((filterItem) => (
//           <button
//             key={filterItem.id}
//             onClick={() => setFilter(filterItem.id)}
//             className={`
//               px-4 py-2 rounded-full font-medium transition-all duration-200
//               flex items-center gap-2 text-sm
//               ${filter === filterItem.id
//                 ? 'bg-primary text-white shadow-md'
//                 : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
//               }
//             `}
//           >
//             <span>{filterItem.icon}</span>
//             <span>{filterItem.label}</span>
//             {filterItem.id !== 'all' && (
//               <span className={`text-xs px-2 py-0.5 rounded-full ${
//                 filter === filterItem.id
//                   ? 'bg-white text-primary'
//                   : 'bg-gray-200 text-gray-600'
//               }`}>
//                 {filteredNegotiations.filter(n => n.status === filterItem.id).length}
//               </span>
//             )}
//           </button>
//         ))}
//       </div>

//       {/* Negotiations List */}
//       {filteredNegotiations.length === 0 ? (
//         <div className="flex flex-col justify-center items-center text-center py-16 bg-gray-50 rounded-xl">
//           <motion.div
//             initial={{ opacity: 0, scale: 0.9 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.4 }}
//           >
//             <img
//               src={empty_box}
//               alt="No Negotiations"
//               className="w-40 lg:w-48"
//             />
//           </motion.div>
//           <div className="font-bold mt-3 text-lg text-gray-700">
//             {filter === 'all' 
//               ? 'لا توجد مفاوضات'
//               : `لا توجد مفاوضات ${filter === 'ACTIVE' ? 'نشطة' : filter === 'COMPLETED' ? 'مكتملة' : 'ملغاة'}`
//             }
//           </div>
//           {filter === 'all' && (
//             <Link 
//               to="/marketplace"
//               className="mt-6 inline-block px-6 py-3 bg-primary text-white rounded-lg hover:bg-primary-dark transition"
//             >
//               استكشف السوق
//             </Link>
//           )}
//         </div>
//       ) : (
//         <div className="flex flex-col gap-4">
//           {filteredNegotiations.map((negotiation, index) => {
//             const status = getStatusBadge(negotiation.status);
//             const unreadCount = negotiation.unreadCount || 0;
            
//             return (
//               <motion.div
//                 key={negotiation.id}
//                 initial={{ opacity: 0, y: 10 }}
//                 animate={{ opacity: 1, y: 0 }}
//                 transition={{ duration: 0.3, delay: index * 0.05 }}
//               >
//                 <Link
//                   to={`/home/negotiations/${negotiation.id}`}
//                   className={`
//                     flex flex-row-reverse items-center text-right justify-between gap-1 md:gap-3 p-2 md:p-4 
//                     rounded-xl shadow-sm transition-all hover:shadow-md hover:scale-[1.02] block
//                     ${unreadCount > 0 ? 'bg-blue-50 border-r-4 border-blue-500' : 'bg-white border border-gray-200'}
//                   `}
//                 >
//                   {/* Image/Icon */}
//                   <div className="flex-shrink-0 relative">
//                     {negotiation.imageUrl ? (
//                       <img
//                         src={negotiation.imageUrl}
//                         alt={negotiation.title}
//                         className="w-14 h-14 rounded-xl object-cover border border-gray-200"
//                       />
//                     ) : (
//                       <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-primary/20 to-primary/10 flex items-center justify-center text-2xl">
//                         {getTypeIcon(negotiation.type)}
//                       </div>
//                     )}
//                     {unreadCount > 0 && (
//                       <div className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center shadow-md">
//                         {unreadCount}
//                       </div>
//                     )}
//                   </div>

//                   {/* Content */}
//                   <div dir="rtl" className="flex flex-col text-right flex-1">
//                     <div className="flex items-center gap-2 flex-wrap">
//                       <div className="font-bold text-base md:text-lg text-gray-800">
//                         {negotiation.title || getTypeText(negotiation.type)}
//                       </div>
//                       <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${status.color} flex items-center gap-1`}>
//                         <span>{status.icon}</span>
//                         <span>{status.text}</span>
//                       </span>
//                     </div>
                    
//                     <div className="text-right text-sm mt-1">
//                       <span className="font-medium text-gray-600">مع: </span>
//                       <span className={unreadCount > 0 ? 'text-black font-semibold' : 'text-gray-600'}>
//                         {getCounterpartyName(negotiation)}
//                       </span>
//                     </div>
                    
//                     {negotiation.quantity && (
//                       <div className="text-right text-xs text-gray-500 mt-0.5">
//                         <span className="font-medium">الكمية: </span>
//                         {negotiation.quantity} {negotiation.unit?.name || 'وحدة'}
//                       </div>
//                     )}
                    
//                     {/* Last message preview */}
//                     {negotiation.lastMessage && (
//                       <div className={`text-right text-sm mt-1 ${unreadCount > 0 ? 'text-black font-semibold' : 'text-gray-500'}`}>
//                         <span className="block truncate max-w-[200px] md:max-w-[300px]">
//                           {negotiation.lastMessage}
//                         </span>
//                       </div>
//                     )}
//                   </div>

//                   {/* Date and indicators */}
//                   <div className="flex flex-col items-end gap-1 min-w-[80px]">
//                     <div className="text-xs text-gray-400 whitespace-nowrap">
//                       {formatDistanceToNow(new Date(negotiation.updatedAt), { 
//                         addSuffix: true, 
//                         locale: ar 
//                       })}
//                     </div>
                    
//                     {negotiation.hasPendingInvoice && (
//                       <div className="flex items-center gap-1 text-xs text-yellow-600 bg-yellow-50 px-2 py-0.5 rounded-full">
//                         <span>📄</span>
//                         <span className="hidden sm:inline">فاتورة</span>
//                       </div>
//                     )}
                    
//                     {negotiation.hasOrder && (
//                       <div className="flex items-center gap-1 text-xs text-green-600 bg-green-50 px-2 py-0.5 rounded-full">
//                         <span>📦</span>
//                         <span className="hidden sm:inline">طلب</span>
//                       </div>
//                     )}
                    
//                     <svg 
//                       className="w-4 h-4 text-gray-400 group-hover:text-primary transition-colors mt-1" 
//                       fill="none" 
//                       stroke="currentColor" 
//                       viewBox="0 0 24 24"
//                     >
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                     </svg>
//                   </div>
//                 </Link>
//               </motion.div>
//             );
//           })}
//         </div>
//       )}
//     </div>
//   );
// };

// export default NegotiationsList;
// src/pages/me/negotiations/index.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { motion } from 'framer-motion';
import { formatDistanceToNow } from 'date-fns';
import { ar } from 'date-fns/locale';
import Client from '../../../utils/client';
import empty_box from '../../../images/empty_box.png';
import { useTranslation } from 'react-i18next';

const NegotiationsList = () => {
    const { t } = useTranslation();
    const currentUserId = localStorage.getItem('user_id');

    // Fetch negotiations with last messages
    const { data: negotiations, isLoading, error, refetch } = useQuery({
        queryKey: ['negotiations'],
        queryFn: async () => {
            const response = await Client.get(`/negotiations/last-messages`).then(
                (res) => res.data
            );
            return response;
        },
        initialData: [],
        enabled: !!currentUserId
    });

    const getStatusBadge = (status) => {
        switch(status) {
            case 'ACTIVE':
                return { 
                    text: t('negotiations.status.active'), 
                    color: 'bg-green-100 text-green-800', 
                    icon: '🟢' 
                };
            case 'COMPLETED':
                return { 
                    text: t('negotiations.status.completed'), 
                    color: 'bg-blue-100 text-blue-800', 
                    icon: '✅' 
                };
            case 'CANCELLED':
                return { 
                    text: t('negotiations.status.cancelled'), 
                    color: 'bg-red-100 text-red-800', 
                    icon: '❌' 
                };
            default:
                return { 
                    text: status || t('common.notSpecified'), 
                    color: 'bg-gray-100 text-gray-800', 
                    icon: '⚪' 
                };
        }
    };

    const getTypeIcon = (type) => {
        switch(type) {
            case 'CROP':
                return '🌾';
            case 'INPUT':
                return '🧪';
            case 'SERVICE':
                return '🔧';
            default:
                return '📦';
        }
    };

    const getTypeText = (type) => {
        switch(type) {
            case 'CROP':
                return t('negotiations.types.crop');
            case 'INPUT':
                return t('negotiations.types.input');
            case 'SERVICE':
                return t('negotiations.types.service');
            default:
                return type;
        }
    };

    const getCounterpartyName = (negotiation) => {
        if (currentUserId === negotiation.buyerId) {
            return negotiation.seller?.name || t('common.seller');
        }
        return negotiation.buyer?.name || t('common.buyer');
    };

    // Skeleton loader component
    const SkeletonLoader = () => (
        <div dir="rtl" className="space-y-4">
            {[...Array(5)].map((_, i) => (
                <div key={i} className="flex flex-row-reverse items-center justify-between gap-3 p-4 bg-gray-100 rounded-xl shadow-sm animate-pulse">
                    <div className="flex-1">
                        <div className="flex items-center gap-2 mb-2">
                            <div className="h-6 bg-gray-300 rounded w-24"></div>
                            <div className="h-5 bg-gray-300 rounded w-16"></div>
                        </div>
                        <div className="h-4 bg-gray-300 rounded w-32 mb-2"></div>
                        <div className="h-3 bg-gray-300 rounded w-48"></div>
                    </div>
                    <div className="w-14 h-14 bg-gray-300 rounded-xl"></div>
                </div>
            ))}
        </div>
    );

    if (isLoading) {
        return (
            <div className="w-full px-4 lg:px-8 py-6">
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-primary mb-2">{t('negotiations.title')}</h1>
                    <p className="text-gray-500">{t('negotiations.subtitle')}</p>
                </div>
                <SkeletonLoader />
            </div>
        );
    }

    if (error) {
        return (
            <div className="w-full px-4 lg:px-8 py-6">
                <div className="mb-8">
                    <h1 className="text-3xl font-bold text-primary mb-2">{t('negotiations.title')}</h1>
                    <p className="text-gray-500">{t('negotiations.subtitle')}</p>
                </div>
                <div className="text-center py-12 bg-red-50 rounded-xl">
                    <p className="text-red-500 mb-4">{t('negotiations.error')}</p>
                    <button 
                        onClick={() => refetch()}
                        className="px-4 py-2 bg-primary text-white rounded-lg hover:bg-primary-dark transition"
                    >
                        {t('common.retry')}
                    </button>
                </div>
            </div>
        );
    }

    const negotiationsList = negotiations || [];

    return (
        <div className="w-full px-4 lg:px-20 relative">
            {/* Header */}
            {/* <div className="mb-8">
                <h1 className="text-3xl font-bold text-primary mb-2">{t('negotiations.title')}</h1>
                <p className="text-gray-500">{t('negotiations.subtitle')}</p>
            </div> */}
            <h1 className="text-end font-bold text-2xl lg:text-3xl my-10 text-primary">
                {/* الإشعارات */}
                {t('negotiations.title')}
            </h1>

            {/* Negotiations List */}
            {negotiationsList.length === 0 ? (
                <div className="flex flex-col justify-center items-center text-center py-16 bg-gradient-to-b from-gray-50 to-white rounded-2xl border border-gray-100">
                    <motion.div
                        initial={{ opacity: 0, scale: 0.9 }}
                        animate={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.4 }}
                    >
                        <img
                            src={empty_box}
                            alt={t('negotiations.noNegotiations')}
                            className="w-40 lg:w-48 opacity-70"
                        />
                    </motion.div>
                    <div className="font-bold mt-4 text-xl text-gray-700">
                        {t('negotiations.noNegotiations')}
                    </div>
                    <p className="text-gray-400 mt-2 mb-6">
                        {t('negotiations.startNegotiationMessage')}
                    </p>
                    <Link 
                        to="/marketplace"
                        className="inline-flex items-center gap-2 px-6 py-3 bg-primary text-white rounded-xl hover:bg-primary-dark transition-all duration-200 hover:scale-105 shadow-md"
                    >
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-1.5 6M17 13l1.5 6M9 21h6M12 15v6" />
                        </svg>
                        {t('negotiations.exploreMarketplace')}
                    </Link>
                </div>
            ) : (
                <div className="grid grid-cols-1 gap-4">
                    {negotiationsList.map((negotiation, index) => {
                        const status = getStatusBadge(negotiation.status);
                        const unreadCount = negotiation.unreadCount || 0;
                        
                        return (
                            <motion.div
                                key={negotiation.id}
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.3, delay: index * 0.05 }}
                                whileHover={{ scale: 1.01 }}
                                className="group"
                            >
                                <Link
                                    to={`/home/negotiations/${negotiation.id}`}
                                    className={`
                                        flex flex-row-reverse items-center gap-4 p-5 
                                        rounded-2xl transition-all duration-300 block
                                        ${unreadCount > 0 
                                            ? 'bg-gradient-to-r from-blue-50 to-white border-r-4 border-primary shadow-md' 
                                            : 'bg-white border border-gray-200 hover:shadow-lg hover:border-primary/30'
                                        }
                                    `}
                                >
                                    {/* Image/Icon */}
                                    <div className="flex-shrink-0 relative">
                                        {negotiation.imageUrl ? (
                                            <img
                                                src={negotiation.imageUrl}
                                                alt={negotiation.title}
                                                className="w-16 h-16 rounded-2xl object-cover border border-gray-200 shadow-sm"
                                            />
                                        ) : (
                                            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary/20 to-primary/5 flex items-center justify-center text-3xl shadow-sm">
                                                {getTypeIcon(negotiation.type)}
                                            </div>
                                        )}
                                        {unreadCount > 0 && (
                                            <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold rounded-full min-w-[22px] h-[22px] flex items-center justify-center shadow-md px-1">
                                                {unreadCount > 99 ? '99+' : unreadCount}
                                            </div>
                                        )}
                                    </div>

                                    {/* Content */}
                                    <div dir="rtl" className="flex-1">
                                        <div className="flex items-center gap-2 flex-wrap mb-2">
                                            <h3 className="font-bold text-lg text-gray-800">
                                                {negotiation.title || getTypeText(negotiation.type)}
                                            </h3>
                                            <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${status.color} flex items-center gap-1`}>
                                                <span>{status.icon}</span>
                                                <span>{status.text}</span>
                                            </span>
                                        </div>
                                        
                                        <div className="text-sm text-gray-600 mb-1">
                                            <span className="font-medium">{t('negotiations.with')}: </span>
                                            <span className={unreadCount > 0 ? 'text-gray-900 font-semibold' : 'text-gray-600'}>
                                                {getCounterpartyName(negotiation)}
                                            </span>
                                        </div>
                                        
                                        {negotiation.quantity && (
                                            <div className="text-xs text-gray-400 mb-1">
                                                <span className="font-medium">{t('negotiations.quantity')}: </span>
                                                {negotiation.quantity} {negotiation.unit?.name || t('negotiations.unit')}
                                            </div>
                                        )}
                                        
                                        {/* Last message preview */}
                                        {negotiation.lastMessage && (
                                            <div className={`text-sm mt-2 ${unreadCount > 0 ? 'text-gray-900 font-medium' : 'text-gray-500'}`}>
                                                <div className="flex items-start gap-1">
                                                    <svg className="w-4 h-4 mt-0.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                                                    </svg>
                                                    <span className="line-clamp-2 break-words flex-1">
                                                        {negotiation.lastMessage}
                                                    </span>
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    {/* Date and indicators */}
                                    <div className="flex flex-col items-end gap-2 min-w-[100px]">
                                        <div className="text-xs text-gray-400 whitespace-nowrap bg-gray-50 px-2 py-1 rounded-full">
                                            {formatDistanceToNow(new Date(negotiation.updatedAt), { 
                                                addSuffix: true, 
                                                locale: ar 
                                            })}
                                        </div>
                                        
                                        <div className="flex gap-1">
                                            {negotiation.hasPendingInvoice && (
                                                <div className="flex items-center gap-1 text-xs text-amber-600 bg-amber-50 px-2 py-1 rounded-full" title={t('negotiations.pendingInvoice')}>
                                                    <span>📄</span>
                                                    <span className="hidden sm:inline text-xs">{t('negotiations.invoice')}</span>
                                                </div>
                                            )}
                                            
                                            {negotiation.hasOrder && (
                                                <div className="flex items-center gap-1 text-xs text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full" title={t('negotiations.activeOrder')}>
                                                    <span>📦</span>
                                                    <span className="hidden sm:inline text-xs">{t('negotiations.order')}</span>
                                                </div>
                                            )}
                                        </div>
                                        
                                        <svg 
                                            className="w-5 h-5 text-gray-300 group-hover:text-primary transition-all duration-300 group-hover:translate-x-1" 
                                            fill="none" 
                                            stroke="currentColor" 
                                            viewBox="0 0 24 24"
                                        >
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                                        </svg>
                                    </div>
                                </Link>
                            </motion.div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default NegotiationsList;